'use client';

import styled from 'styled-components';
import { useTranslations } from 'next-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { useCasinoTheme } from './CasinoThemeProvider';
import { calendarPalette as palette } from './calendar-stuff/CalendarPalette';

const Toggle = styled.button`
  position: absolute;
  top: 0;
  right: 88px;
  z-index: 280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid ${palette.border};
  border-top: 0;
  border-radius: 0 0 6px 6px;
  background: ${palette.heading};
  color: ${palette.onDark};
  font-size: .8rem;
  font-weight: 600;
  cursor: pointer;
  &:hover { background: ${palette.heroMid}; }
  &:focus-visible { outline: 3px solid ${palette.gold}; outline-offset: 3px; }
  svg { width: 14px; height: 14px; color: ${palette.gold}; }
`;

export default function ThemeToggle() {
  const { active, mode, toggleTheme } = useCasinoTheme();
  const t = useTranslations('ThemeToggle');
  if (!active) return null;
  const dark = mode === 'dark';

  return (
    <Toggle type="button" onClick={toggleTheme} aria-pressed={dark}
      aria-label={t('DarkMode')} title={t(dark ? 'SwitchToLight' : 'SwitchToDark')}>
      <FontAwesomeIcon icon={dark ? faSun : faMoon} aria-hidden="true" />
      <span>{t(dark ? 'LightMode' : 'DarkMode')}</span>
    </Toggle>
  );
}
